import React, { useEffect, useState } from "react";
import Slider from "@mui/material/Slider";
import { Send } from "lucide-react";
import Button from "@mui/material/Button";
import { fetchDataFromApi } from "../../utils/api";
import "./index.css";

const Slidebar = ({
  selectedCategory,
  setSelectedCategory,
  priceRange,
  setPriceRange,
  ratingFilter,
  setRatingFilter,
  onApplyFilters,
}) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetchDataFromApi("/api/category");
        if (res?.categoryList) setCategories(res.categoryList);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCategories();
  }, []);

  const handlePriceChange = (event, newValue) => {
    setPriceRange(newValue);
  };

  const handleRatingClick = (rating) => {
    // If the same rating is clicked again, clear the filter
    if (ratingFilter === rating.toString()) {
      setRatingFilter("");
    } else {
      setRatingFilter(rating.toString());
    }
  };

  const handleCategoryClick = (categoryId) => {
    console.log("Category clicked:", categoryId);
    setSelectedCategory(categoryId);
  };

  const handleApplyFilters = () => {
    onApplyFilters();
  };

  // Function to render stars only (no text)
  const renderStars = (rating) => {
    return (
      <span className="rating-stars d-flex align-items-center">
        {Array.from({ length: 5 }, (_, index) => (
          <span
            key={index}
            style={{
              color: index < rating ? "#ffc107" : "#e4e5e9",
              fontSize: "16px",
              marginRight: "1px"
            }}
          >
            ★
          </span>
        ))}
      </span>
    );
  };

  return (
    <div className="slidebar p-2">
      <div
        className="p-3 mb-3"
        style={{ borderRadius: "12px" }}
      >
        <h5 className="mb-3">Categories</h5>
        <div className="catList d-flex flex-column gap-2">
          <div
            className={`catItem fixed-width-category p-2 rounded cursor-pointer transition-all ${selectedCategory === "all"
                ? "bg-success text-white"
                : "bg-light hover:bg-gray-100"
              }`}
            style={{
              cursor: "pointer",
              transition: "all 0.3s ease",
              border:
                selectedCategory === "all"
                  ? "2px solid #28a745"
                  : "1px solid #e9ecef",
            }}
            onClick={() => handleCategoryClick("all")}
          >
            <strong>All Products</strong>
          </div>
          {categories.map((cat) => (
            <div
              key={cat._id}
              className={`catItem fixed-width-category p-2 rounded cursor-pointer transition-all ${selectedCategory === cat._id
                  ? "bg-success text-white"
                  : "bg-light hover:bg-gray-100"
                }`}
              style={{
                cursor: "pointer",
                transition: "all 0.3s ease",
                border:
                  selectedCategory === cat._id
                    ? "2px solid #28a745"
                    : "1px solid #e9ecef",
              }}
              onClick={() => handleCategoryClick(cat._id)}
            >
              {cat.name}
            </div>
          ))}
        </div>
      </div>

      <div className="p-3" style={{ borderRadius: "12px" }}>
        <h5 className="mb-3">Filter by Price</h5>
        <div className="px-2">
          <Slider
            min={0}
            max={1000}
            value={priceRange}
            onChange={handlePriceChange}
            valueLabelDisplay="auto"
            color="success"
            sx={{
              "& .MuiSlider-thumb": {
                backgroundColor: "#28a745",
              },
              "& .MuiSlider-track": {
                backgroundColor: "#28a745",
              },
              "& .MuiSlider-rail": {
                backgroundColor: "#e9ecef",
              },
            }}
          />
        </div>
        <div className="d-flex justify-content-between mt-2 mb-4">
          <span className="badge bg-success">₹{priceRange[0]}</span>
          <span className="badge bg-success">₹{priceRange[1]}</span>
        </div>

        <h5 className="mb-3">Filter by Rating</h5>
        <div className="mb-2">
          {/* All Ratings Option */}
          <div
            className={`rating-option p-1 mb-1 rounded cursor-pointer ${ratingFilter === ""
                ? "bg-success text-white"
                : "bg-light"
              }`}
            style={{
              cursor: "pointer",
              transition: "all 0.3s ease",
              border: ratingFilter === ""
                ? "2px solid #28a745"
                : "1px solid #e9ecef",
            }}
            onClick={() => setRatingFilter("")}
          >
            <span>All Ratings</span>
          </div>

          {/* Star Rating Options - Only 4 stars and below, stars only */}
          {[4, 3, 2, 1].map((rating) => (
            <div
              key={rating}
              className={`rating-option p-1 mb-1 rounded cursor-pointer ${ratingFilter === rating.toString()
                  ? "bg-success text-white"
                  : "bg-light hover:bg-gray-100"
                }`}
              style={{
                cursor: "pointer",
                transition: "all 0.3s ease",
                border:
                  ratingFilter === rating.toString()
                    ? "2px solid #28a745"
                    : "1px solid #e9ecef",
              }}
              onClick={() => handleRatingClick(rating)}
            >
              {renderStars(rating)}
            </div>
          ))}
        </div>

        <Button
          variant="contained"
          color="success"
          startIcon={<Send />}
          className="mt-3 w-100"
          onClick={handleApplyFilters}
          sx={{
            backgroundColor: "#28a745",
            "&:hover": {
              backgroundColor: "#218838",
            },
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );
};

export default Slidebar;